<!--  / eslint-disable no-new / -->
<template>
  <div
    :class="[
      'run-code-content',
      'training-area-right',
      { 'training-area-right-off': !sidebarSwitch },
    ]"
  >
    <!-- 运行工具edit-tool -->
    <div :class="['edit-tool', { 'edit-tool-off': !workspaceIsVisible }]">
      <el-button class="btn-undo-redo" title="撤销" @click="undoHandle">
        <icon-base
          class="icon-undo-redo icon-undo"
          :icon-name="Icons.UndoOrRedo.undo"
          v-bind="Icons.UndoOrRedo.data"
        >
          <icon-undo-or-redo />
        </icon-base>
      </el-button>
      <el-button class="btn-redo-redo" title="重做" @click="redoHandle">
        <icon-base
          class="icon-undo-redo icon-redo"
          :icon-name="Icons.UndoOrRedo.redo"
          v-bind="Icons.UndoOrRedo.data"
        >
          <icon-undo-or-redo />
        </icon-base>
      </el-button>
      <el-button title="整理" @click="resetSvg">
        <icon-base
          class="icon-undo-redo icon-redo"
          :icon-name="Icons.DeskToday.iconName"
          v-bind="Icons.DeskToday"
        >
          <icon-desk-today />
        </icon-base>
      </el-button>
    </div>
    <div class="run-head">
      <div v-show="false" class="title">数据运算</div>
      <el-button @click="codeRunHandle" v-show="sidebarSwitch">
        <icon-base
          id="button_run"
          class="icon-code-run"
          :icon-base="Icons.CodeRun.iconName"
          v-bind="Icons.CodeRun"
        >
          <icon-code-run />
        </icon-base>
        {{ !running ? '运行' : '停止' }}
      </el-button>
      <el-button @click="clearWorkspace" v-show="sidebarSwitch">
        <icon-base
          class="icon-code-clear"
          :icon-base="Icons.CodeClear.iconName"
          v-bind="Icons.CodeClear"
        >
          <icon-code-clear />
        </icon-base>
        清除
      </el-button>
      <el-button
        :class="{ 'sibebar-switch-off': !sidebarSwitch }"
        @click="sidebarSwitchHandle"
      >
        <icon-base
          class="icon-sibebar-switch"
          :icon-name="Icons.SidebarSwitch.iconName"
          v-bind="Icons.SidebarSwitch"
        >
          <icon-sibebar-switch />
        </icon-base>
      </el-button>
    </div>
    <!-- 代码运行结果模块 -->
    <div class="run-result">
      <div
        id="runMsgSuccess"
        :class="['run-msg-success', { 'run-msg-hide': !runStasus }]"
      >
        <i class="icon_box" v-show="runStasus === 'success'">
          <icon-base
            class="icon-run-success"
            :icon-name="Icons.RunSuccess.iconName"
            v-bind="Icons.RunSuccess"
          >
            <icon-run-success />
          </icon-base>
        </i>
        {{ Message.runCode[runStasus] }}
        <span class="error-btn" v-show="runStasus == 'fail'" @click="showError"
          >报错信息>
        </span>
        <p class="error-info" v-show="errorStatus">{{ errorText }}</p>
      </div>
      <!-- 运行区结果 -->
      <div
        id="runMsgCmd"
        class="run-msg-cmd"
        v-for="(item, index) of codeResult"
        :key="index"
      >
        {{ item }}
      </div>
    </div>

    <!--分区 显示区域数组 -->
    <div
      :class="['run-ai', { 'run-ai-full-screen': isFullScreen }]"
      ref="runAi"
      id="run-ai"
    >
      <!-- 头部 -->
      <div class="run-ai-head">
        <!-- <span class="title ellipsis">{{
          Train.trainingName || Project.projectName
        }}</span> -->
        <tooltip-box
          class="title"
          :textRef="'trainingNametips'"
          :textId="'123456'"
          :textRow="1"
          :textName="Train.trainingName || Project.projectName"
          :placement="'top'"
          :tooltipShow="false"
        ></tooltip-box>
        <el-button
          class="full-screen"
          :title="
            isFullScreen
              ? Icons.ExitFullScreen.iconName
              : Icons.FullScreen.iconName
          "
          @click="fullScreen"
        >
          <icon-base
            class="icon-full-screen"
            :icon-name="Icons.FullScreen.iconName"
            v-bind="Icons.FullScreen"
            v-show="!isFullScreen"
          >
            <icon-full-screen> </icon-full-screen>
          </icon-base>
          <icon-base
            class="icon-full-screen"
            :icon-name="Icons.ExitFullScreen.iconName"
            v-bind="Icons.ExitFullScreen"
            v-show="isFullScreen"
          >
            <icon-exit-full-screen> </icon-exit-full-screen>
          </icon-base>
        </el-button>
      </div>
      <!-- 小聪、小智编辑器显示区 -->
      <!--判断：当有标题时，不显示背景-->
      <div
        :class="[
          'run-ai-area',
          {
            'run-ai-area-bg-remove': viewImgArr.length == 'success',
          },
        ]"
      >
        <!-- 文本显示-->
        <div class="run-ai-area-msg">
          <div class="msg-wrap" v-if="viewMsgArr && viewMsgArr.length">
            <p v-for="(item2, idx) in viewMsgArr" :key="idx">
              {{ item2 }}
            </p>
          </div>
          <!-- 文本文件的显示  -->
          <!-- <div
            class="txt-file-content"
            v-for="(item3, idx) in partNumArr[index].textUrl"
            :key="idx"
            v-html="item3"
          ></div> -->
        </div>
        <!-- 图片显示-->
        <div class="run-ai-area-pic" v-if="viewImgArr.length">
          <img
            v-for="(imgItem, subIndex) of viewImgArr"
            :key="subIndex"
            :src="imgItem"
            :style="{
              width: `${100 / viewImgArr.imgLength}%`,
              transform: `scale(${imgItem.size})`,
            }"
            alt
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// api
import RUN from '@/axios/pythonRun/run.js'
// import gtaAudio from '@/components/common/Audio'
import { mapGetters } from 'vuex'
// 图标
import IconUndoOrRedo from '@/components/icons/typography/UndoOrRedo'
import IconDeskToday from '@/components/icons/typography/DeskToday'
import IconSibebarSwitch from '@/components/icons/typography/SidebarSwitch'
import IconCodeRun from '@/components/icons/typography/CodeRun'
import IconCodeClear from '@/components/icons/typography/CodeClear'
import IconRunSuccess from '@/components/icons/typography/RunSuccess'
import IconFullScreen from '@/components/icons/typography/FullScreen'
import IconExitFullScreen from '@/components/icons/typography/ExitFullScreen'
import TooltipBox from '@/components/common/TooltipBox'
//公共方法
import bus from '@/utils/bus'
import { debounce } from 'lodash'
//混入-socket.io的功能
import { mixinSocketIO } from '@/assets/js/mixin/mixinSocketIO.js'

// import util from '@/utils/index.js'
require('skulpt/dist/skulpt.min.js')
require('skulpt/dist/skulpt-stdlib.js')
var Sk = window.Sk
export default {
  name: 'BaseCodeRun',
  components: {
    // gtaAudio,
    IconUndoOrRedo,
    IconDeskToday,
    IconSibebarSwitch,
    IconCodeRun,
    IconCodeClear,
    IconRunSuccess,
    IconFullScreen,
    IconExitFullScreen,
    TooltipBox
  },
  props: {
    //     codeText: {
    //       type: String,
    //       default:'import turtle\n' +
    //         'turtle.color(\'red\')\n' +
    //         'wn = turtle.Screen()\n' +
    //         'babbage = turtle.Turtle()\n'+
    //         'babbage.shape("triangle")\n'+
    //         `n = 8\n
    // angle = 360/n\n

    // for i in range(n):\n
    //     babbage.right(angle)\n
    //     babbage.forward(50)\n
    //     babbage.stamp()\n
    // wn.exitonclick()\n`
    // +'print("hello")',
    //     },
    projectId: {
      type: String,
      default: null,
    },

    uuid: {
      type: String,
      default: null,
    },
    editorLabel: {
      type: String,
      default: null,
    },
    Project: {
      type: Object,
      default: () => {
        return {}
      },
    },
    workspaceIsVisible: {
      type: Boolean,
      default: true,
    },
  },
  mixins: [mixinSocketIO],
  data() {
    return {
      // pythonCodeResult:null,
      runResult: {
        // cmdstr: "代码运行结果",
        // msg: "特定函数调用结果列表"
      },
      errorMsg: null, //错误信息
      errorText: null, //错误信息
      errorStatus: false,
      sidebarSwitch: true,
      hasRunSuccess: false,
      ifCreateBlock: false,
      runStasus: null,
      running: null, //运行区请求的状态，true表示正在请求
      codeResult: [],
      aiBlockResult: {}, //智能积木对象
      partNumTitleArr: ['标题'], //存放无人小车功能解析的参数
      gtaFunDriveArr: [], //储存各个分区标题
      hasMediaAttr: false,
      partNumArr: [{ imgArr: [] }], //显示区内容
      viewImgArr: [], //显示区图片
      viewMsgArr: [], //显示区文本
      mediaArr: [], //摄像头数组
      aiBlockArr: [], //摄像头显示的功能
      audioList: [], //音频功能数组
      codeTextResult: '',
      isFullScreen: false,
      isMeida: null, //是否存在摄像头
      partNum: 1,
      isPart: false, //工作区积木是否有分区积木;
      partIndex: 1, //分区索引
      partWidth: null,
      partHeight: null,
      mediaWidth: null,
      mediaHeight: null,
      offsetWidth: null,
      offsetHeight: null,
      MediaOffsetTop: null, //摄像头上偏移距离
      MediaOffsetLeft: null, //摄像头左偏移距离
      beMark: false, //遮罩层
      mediaDomain: window.gtaAiConfig.netCameraObj.host,
      robotSocket: window.gtaAiConfig.robot_socket, //socket的连接
      robotPortA: window.gtaAiConfig.robot_port_a, //socket的端口
      robotPortB: window.gtaAiConfig.robot_port_b, //socket的端口
      Message: {
        runCode: {
          loading: '正在运行中...',
          fail: '运行失败！',
          success: '运行成功！',
          noText: '没有运行的脚本！',
        },
      },

      Icons: {
        NavFile: {
          iconName: '文件',
          viewBox: '0 0 19 18',
          width: '19',
          height: '18',
          iconColor: '#fff',
        },
        NavSave: {
          iconName: '保存',
          viewBox: '0 0 18 19',
          width: '18',
          height: '19',
          iconColor: '#fff',
        },
        ModeCode: {
          iconName: '代码模式',
          viewBox: '0 0 16 15',
          width: '16',
          height: '15',
          iconColor: '#5883ff',
        },
        HeadHelp: {
          iconName: '使用文档',
          viewBox: '0 0 24 24',
          width: '24',
          height: '24',
          iconColor: '#fff',
        },
        // 撤销或重做
        UndoOrRedo: {
          undo: '撤销',
          redo: '重做',
          data: {
            // iconName: "撤销或重做",
            viewBox: '0 0 18 15',
            width: '18',
            height: '15',
          },
        },
        // 桌面整理
        DeskToday: {
          iconName: '整理',
          viewBox: '0 0 17 13',
          width: '17',
          height: '13',
        },
        SidebarSwitch: {
          iconName: '收起',
          viewBox: '0 0 13 14',
          width: '13',
          height: '14',
        },
        CodeRun: {
          iconName: '运行',
          viewBox: '0 0 16 16',
          width: '16',
          height: '16',
        },
        CodeClear: {
          iconName: '清除',
          viewBox: '0 0 16.03 15',
          width: '16.03',
          height: '15',
        },
        RunSuccess: {
          iconName: '运行成功',
          viewBox: '0 0 16 16',
          width: '16',
          height: '16',
        },
        FullScreen: {
          iconName: '全屏',
          viewBox: '0 0 19 19',
          width: '19',
          height: '19',
        },
        ExitFullScreen: {
          iconName: '退出全屏',
          viewBox: '0 0 21 21',
          width: '21',
          height: '21',
        },
        createBlockTextLength: 0, //创建积木脚本长度
        newBlockPythonCode: '', //创建积木脚本长度
      },
      codeText: '',
    }
  },
  //监听属性 类似于data概念
  computed: {
    ...mapGetters(['Train']),
  },

  watch: {},
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {},
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
    var self = this
    this.$nextTick(() => {
      self.getHeightWidth(self.partNum)
    })
    bus.$on('codeRunHandle', () => {
      self.codeRunHandle()
    })
  },
  beforeDestroy() {
    bus.$off('codeRunHandle')
  },
  methods: {
    //skulpt工具运行python脚本
    runIt(codeText) {
      // 页面不能格式化
      let _this = this
      let prog = codeText
      let myPromise
      function builtinRead(x) {
        if (
          Sk.builtinFiles === undefined ||
          Sk.builtinFiles['files'][x] === undefined
        )
          throw "File not found: '" + x + "'"
        return Sk.builtinFiles['files'][x]
      }

      function outf(text) {
        _this.codeResult.push(text)
        console.log('text', text)
      }
      ;(Sk.TurtleGraphics || (Sk.TurtleGraphics = {})).target = 'skulpt-turtle'
      // (Sk.TurtleGraphics || (Sk.TurtleGraphics = {})).target = 'mycanvas';

      Sk.configure({
        output: outf,
        read: builtinRead,
        __future__: Sk.python3,
      })

      myPromise = Sk.misceval.asyncToPromise(function() {
        return Sk.importMainWithBody('<stdin>', false, prog, true)
      })
      myPromise.then(
        function(mod) {
          _this.runStasus = 'success'
        },
        function(err) {
          _this.errorText = err.toString()
          _this.errorStatus = true
          _this.runStasus = 'fail'
          console.log('_this.errorText:', err.toString())
        }
      )
    },
    showError() {
      this.errorStatus = !this.errorStatus
    },
    undoHandle() {
      var undoDom = document.getElementById('btnUndo')
      if (undoDom) {
        undoDom.click()
      }
    },
    redoHandle() {
      var redoDom = document.getElementById('btnRedo')
      if (redoDom) {
        redoDom.click()
      }
    },
    resetSvg() {
      var resetSvgDom = document.getElementById('btnResetSvg')
      if (resetSvgDom) {
        resetSvgDom.click()
      }
    },

    //从文本路径中获取到文本内容
    getTextFromUrl(partIndex, textUrl) {
      let self = this
      let word, text
      this.$axios({
        url: textUrl,
        method: 'get',
        headers: { 'Content-Type': 'application/json;charset=utf-8' },
        // headers: { 'Content-Type': 'application/json' },
        responseType: 'arraybuffer',
      }).then((result) => {
        const iconv = require('iconv-lite')
        const datas = new Uint8Array(result)
        text = iconv.decode(datas, 'gb18030') //解析成字符串

        // let jschardet = require("jschardet")
        // let codeObj = jschardet.detect(text,{ minimumThreshold: 0})
        // console.log('上传的文件encodeing',codeObj);

        console.log('text', text)
        word = text.replace(/\n|\r\n/g, '<br/>')
        self.partNumArr[partIndex - 1].textUrl.push(word)
        self.$forceUpdate()
      })
    },
    /**
      *
      *
     以下为运行前对python脚本解析的方法
     **/
    //分区的宽高
    getHeightWidth(partNum) {
      var self = this
      setTimeout(() => {
        var runAi = this.$refs.runAi,
          // var runAi = document.getElementsByClassName("run-ai")[0],
          partWidth,
          partHeight
        var offsetWidth = runAi.offsetWidth
        var offsetHeight = runAi.offsetHeight
        if (partNum == 4) {
          partWidth = (offsetWidth / partNum) * 2
          partHeight = ((offsetHeight - 40) / partNum) * 2
        } else if (partNum == 9) {
          partWidth = (offsetWidth / partNum) * 3
          partHeight = ((offsetHeight - 40) / partNum) * 3
        } else {
          partWidth = offsetWidth
          partHeight = offsetHeight - 40
        }
        self.offsetWidth = offsetWidth
        self.offsetHeight = offsetHeight
        self.partWidth = partWidth - 2.5 //宽度减少5像素
        self.partHeight = partHeight

        // 摄像头积木的宽高
        var tempWidth = (partWidth * 9) / 16
        // debugger;
        if (tempWidth < partHeight) {
          //非全屏
          this.mediaWidth = partWidth //宽度减少5像素
          this.mediaHeight = ((partWidth * 9) / 16).toFixed(0)
          this.MediaOffsetTop = Math.ceil((partHeight - this.mediaHeight) / 2)
          this.MediaOffsetLeft = 0
        } else {
          //全屏
          this.mediaHeight = partHeight
          this.mediaWidth = ((partHeight * 16) / 9).toFixed(0) //宽度减少5像素
          this.MediaOffsetTop = 0
          this.MediaOffsetLeft = Math.ceil((partWidth - this.mediaWidth) / 2)
        }
      }, 100)
    },

    //运行积木代码
    async codeRunHandle() {
      //在一个请求结束前禁止再次请求
      if (this.running) {
        return this.stopRun() //停止运行
      }
      this.runStasus = null
      //代码运行结果
      var self = this
      self.codeResult = [] //清空运行区缓存
      self.audioList = [] //清空音频缓存
      this.viewImgArr = []
      this.viewMsgArr = []
      this.runResult = {}
      
      await this.$emit('runHandle') //直接调用父组件，间接调用BlocklyEditer.vue组件
      this.errorText = ''
      // let codeText = this.codeText
      let codeText = this.$store.state.blocklyHome.codeText
      let uuid = this.uuid
      let port
      if (this.editorLabel == 'robotA') {
        port = this.robotPortA
      } else if (this.editorLabel == 'robotB') {
        port = this.robotPortB
      }
      let data = {
        codeStr: codeText,
        fileid: uuid,
      }
      //链接socket
      let wsUrl = this.robotSocket + ':' + port
      console.log('wsUrl', wsUrl)
      await this.socketConnect(wsUrl)

      this.socketRun(data)

      return

      codeText = this.codeTextHandler(codeText)

      if (!this.runStasus && codeText) {
        this.runStasus = 'loading'
      } else if (!codeText) {
        this.runStasus = 'noText'
      }
      // console.log('codeText', codeText)
      if (codeText) {
        //代码运行进行分区运行和显示
        // let status= await this.runPart(codeText)
        // if(status ===false) return;
        //创建积木步骤2  运行积木脚本成功后并分离创建积木的脚本

        //  this.runIt(codeText)
        // 执行python后台接口
        let res = await this.runCode(codeText)
        // return res
      }
    },

    /**
      *
      *
     python代码运行接口
     **/
    runCode(codeText) {
      // 处理后的文本
      let self = this
      let codeTextResult = codeText
      let uuid = this.uuid
      let formData = new FormData()
      formData.append('codeStr', codeTextResult)
      formData.append('fileid', uuid)
      //表示正在运行请求
      this.running = true
      return RUN.RunCodeGl(formData)
        .then((result) => {
          self.runStasus = result.status ? 'success' : 'fail'
          //表示运行请求结束
          self.running = false
          if (result.status) {
            this.runResult = result.data
            //表示运行成功
            this.hasRunSuccess = true
            //全局变量
            this.$store.state.blocklyHome.hasRunSuccess = true
            self.partNumArr.find((item) => {
              if (item.aiBlockArr && item.aiBlockArr.length > 0) {
                self.hasMediaAttr = true
              }
            })
            if (self.hasMediaAttr) {
              //反复请求
              self.codeRunHandle()
            }
            this.errorMsg = null
          } else {
            //表示运行失败
            this.hasRunSuccess = false
            //全局变量
            this.$store.state.blocklyHome.hasRunSuccess = false
            this.errorMsg = result.ErrorMsg
          }
          return result
        })
        .catch((err) => {
          console.log(err)
          //表示运行请求结束
          self.running = false
        })
    },

    //接口：停止运行果力机器人
    stopRun() {
      let uuid = this.uuid
      let formData = new FormData()
      formData.append('fileid', uuid)
      return RUN.TerminateGl(formData).then((result) => {
        // if (result.IsSuccess) {
        // } else {
        // }
      })
    },
    codeTextHandler(codeText) {
      let reg_turtle_pen = /gta_pen|turtle/
      let reg_robot = /Robot\(/

      if (reg_turtle_pen.test(codeText)) {
        codeText = 'import turtle\n' + 'gta_pen = turtle.Turtle()\n' + codeText
      }

      if (reg_robot.test(codeText)) {
        codeText =
          '# -*- coding: gbk -*-\n' + 'from robot import Robot\n' + codeText
      }

      return codeText
    },
    //获取标题积木的信息并修改
    getTitleInfo(str, partIndex) {
      str = str.replace('partName=', '').trim()
      var titleArr = eval(str), //字符串转为js对象
        index = eval(titleArr[0]),
        title = titleArr[1]
      if (index <= this.partNumTitleArr.length) {
        this.partNumTitleArr[index - 1] = title
      }
    },
    /**
      *
      *
     python代码运行后的解析方法
     **/
    //逐行运行结果处理
    runResultHandle(newVal) {
      if (newVal && newVal.activated) {
        let { activated } = newVal

        //防抖函数
        bus.$emit('stepHighlightBlock', activated)
      }
      let msg, cmdstr

      if (newVal.cmdstr) {
        if (newVal.msg) {
          msg = JSON.parse(JSON.stringify(newVal.msg))
        }
        cmdstr = JSON.parse(JSON.stringify(newVal.cmdstr))

        //运行区的文本解析
        if (cmdstr && cmdstr.length) {
          this.runResultToDom(cmdstr)
        }
        //显示区的解析
        if (msg) {
          this.printToDom(msg)
        }
      }
    },
    // 逐行运行错误的处理
    errorMsgHandle(obj) {
      this.runStasus = 'fail'
      console.log('runStasus', this.runStasus)

      if (obj && typeof obj == 'string') {
        this.errorText = obj
      } else if (obj && typeof obj == 'object') {
        // val.forEach((obj) => {
        let values = Object.values(obj)
        if (values.length > 0) {
          values.forEach((arr) => {
            if (Array.isArray(arr)) {
              let text = arr.join(';') // arr
              this.errorText += text
            } else {
              let text = arr
              this.errorText += text
            }
          })
        }
        // })
      } else {
        this.errorText = null
      }
    },
    //运行区：文本解析
    runResultToDom(cmdstr) {
      let valuesArr, valuesStr
      if (typeof cmdstr == 'string') {
        valuesStr = cmdstr
        console.log('valuesStr', valuesStr)
        this.codeResult.push(valuesStr)
      } else {
        console.log('valuesStr--2', valuesStr)
        valuesArr = Object.values(cmdstr)[0]
        if (valuesArr && valuesArr.length) {
          this.CodeSetInterval(valuesArr)
        }
      }
    },
    //显示区：解析
    printToDom(msg) {
      let key,
        valuesArr,
        partIndex,
        reg_part = /PART_/g
      // debugger
      if (msg instanceof Array) {
        for (var i = 0, len = msg.length; i < len; i++) {
          this.printSetInterval(msg[i])
        } //for i end
      } else {
        this.printSetInterval(msg)
      }
    },

    //显示区的解析
    printSetInterval(obj) {
      let _this = this,
        reg_6 = /{/g,
        reg_7 = /}/g,
        reg_img = /^(\s|\S)+(jpg|gif|png|bmp|jpeg|.m3u8)/i,
        reg_rtsp = /(rtsp|rtmp):/,
        reg_url = /^^((http|https):\/\/).*/i, //识别url
        reg_text_url = /^^((http|https):\/\/).*(.txt)/i, //识别音频函数
        funstr = obj.funstr,
        decstr = obj.decstr
      console.log('funstr', funstr)
      console.log('decstr', decstr)

      if (funstr && funstr == 'GTAPrint') {
        if (decstr instanceof Array) {
          for (let i = 0; i < decstr.length; i++) {
            let str = decstr[i]
            if (reg_url.test(str)) {
              this.$nextTick(() => {
                _this.viewImgArr.push(str)
                _this.$forceUpdate()
              })
            } else {
              _this.viewMsgArr.push(str)
            }
          }
        } else if (decstr instanceof String) {
          if (reg_url.test(decstr)) {
            this.$nextTick(() => {
              _this.viewImgArr.push(decstr)
              _this.$forceUpdate()
            })
          } else {
            _this.viewMsgArr.push(decstr)
          }
        }
      }
    },

    clearWorkspace() {
      // 清除积木编辑区域
      // this.$refs.blockly.clearWorkspace();
      // 清除运行结果区域
      this.runResult = {}
      this.runStasus = ''
      this.codeResult = []
      this.viewImgArr = []
      this.viewMsgArr = []
      try {
        this.socketDisconnect()
      } catch (e) {}
    },
    // 重绘
    sidebarSwitchHandle(val) {
      this.sidebarSwitch =
        val === 'codeRun' ? this.sidebarSwitch : !this.sidebarSwitch
      let switchObj = {
        sidebarSwitch: this.sidebarSwitch,
        type: 'codeRun',
      }
      bus.$emit('onSidebarSwitch', switchObj)
    },
    codeRunSwitchHandler(sidebarSwitch) {
      this.sidebarSwitch = sidebarSwitch
    },
    fullScreen() {
      // TODO: 全屏操作
      this.isFullScreen = !this.isFullScreen
      this.getHeightWidth(this.partNum) //重新计算宽高;
    },
  }, // methods end
  updated() {}, //生命周期 - 更新之后
  destroyed() {}, //生命周期 - 销毁完成
  activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
}
</script>
<style lang="scss" scoped>
@import './HardwareCodeRun.scss';
</style>
<style lang="scss">
.el-message-box__wrapper {
  .el-message-box {
    .el-message-box__header {
      margin-top: 30px;
      color: rgba(103, 140, 255, 8);
      padding-bottom: 10px;
    }
    .el-message-box__content {
      text-align: left;
      padding-bottom: -10px !important;
    }
    .el-message-box__btns {
      padding-top: 0px !important;
      button:nth-child(1) {
        background: rgba(103, 140, 255, 1);
      }
    }
  }
}
</style>
